'use es6';

import PropTypes from 'prop-types';
import { forwardRef, useContext } from 'react';
import { hidden } from '../utils/propTypes/decorators';
import { MODAL_USE_CLASSES } from './DialogConstants';
import AbstractModal from './internal/AbstractModal';
import ModalTransition from './internal/ModalTransition';
import UIModalDialog from './UIModalDialog';
import { createPlacementWarning, DropdownContext } from '../context/DropdownContext';
import { jsx as _jsx } from "react/jsx-runtime";
const UIModal = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    shouldLogModalWarning
  } = useContext(DropdownContext);
  const _createPlacementWarning = createPlacementWarning(UIModal.displayName);
  if (shouldLogModalWarning) {
    _createPlacementWarning();
  }
  return /*#__PURE__*/_jsx(AbstractModal, Object.assign({}, props, {
    componentName: "UIModal",
    Transition: ModalTransition,
    ref: ref
  }));
});
UIModal.propTypes = Object.assign({}, UIModalDialog.propTypes, {
  /**
   * Identifies what component is rendered within `UIModal` and takes in its props. By default set to `UIModalDialog`.
   */
  ModalDialog: hidden(PropTypes.func),
  /**
   * Function that gets called when the closing animation is complete.
   */
  onCloseComplete: PropTypes.func,
  /**
   * Function that gets called when the closing animation starts
   */
  onCloseStart: PropTypes.func,
  /**
   * Function that gets called when the opening animation is complete.
   */
  onOpenComplete: PropTypes.func,
  /**
   * Function that gets called when the opening animation starts.
   */
  onOpenStart: PropTypes.func,
  /**
   * Determines how the modal is visually styled based on its use case
   */
  use: PropTypes.oneOf(Object.keys(MODAL_USE_CLASSES)).isRequired,
  /**
   * Allows us to toggle between sandbox and product environment.
   */
  _contextual: PropTypes.bool,
  /**
   * The DOM node where the modal is rendered, by default set to `document.body`.
   */
  rootNode: AbstractModal.propTypes.rootNode
});

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UIModal.defaultProps = Object.assign({}, UIModalDialog.defaultProps, {
  ModalDialog: UIModalDialog,
  _contextual: false
});
UIModal.displayName = 'UIModal';
export default UIModal;